<template>
  <div class="invoice-details-progress">
    <div class="progress-con" v-if="invoiceDetail !==null && invoiceDetail.length > 0">
      <div class="progress-header">
        <div class="progress-title">
          <div v-if="invoiceStatus===3">我们将尽快开具，为您发送至{{ invoiceDetail[0].gmfMobile ? '手机号' : '邮箱' }}</div>
          <div v-if="invoiceStatus===2">开票失败</div>
          <div v-if="invoiceStatus===1">发票已发送至{{ invoiceDetail[0].gmfMobile ? '手机号' : '邮箱' }}</div>
        </div>
        <div class="progress-detail">
          <div class="detail-title">进度</div>
          <div class="detail-detail-con">
            <div class="detail-date" v-if="invoiceDetail && invoiceDetail.length > 0">
              <div class="detail-date-item">
                <div class="radius"></div>
                <div>用户申请开票</div>
                <div class="progress-date">{{formatDateString(invoiceDetail[0].createdTime,0)}}</div>
              </div>
              <div class="detail-date-item" :class="invoiceStatus===3 ? 'active' :''">
                <div class="radius"></div>
                <div class="line"></div>
                <div>发票开具中</div>
                <div class="progress-date">{{formatDateString(invoiceDetail[0].createdTime,0)}}</div>
              </div>
              <div v-if="invoiceStatus===1 " class="detail-date-item" :class="invoiceStatus===1 ? 'active' :''">
                <div class="radius" :class="{noRadius:invoiceStatus!==1}"></div>
                <div class="line" :style="invoiceStatus===1?'background-color: #F8C533':'background-color: #CCCCCC'"></div>
                <div>开票成功</div>
                <div class="progress-date">{{formatDateString(invoiceDetail[0].kprq)}}</div>
              </div>
              <div v-if="invoiceStatus===2" class="detail-date-item" :class="invoiceStatus===2 ? 'active' :''">
                <div class="radius" style="background-color: #FF0000"></div>
                <div class="line" style="background-color: #FF0000"></div>
                <div style="color: #FF0000">开票失败</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="progress-main">
        <div class="detail-title">开票明细</div>
        <div class="invoice-info">
          <div class="info-item" v-for="(i,idx) in invoiceDetail" :key="idx">
            <div class="item-con">
              <div class="invoice-index">发票{{idx+1}}</div>
              <div class="item-price">
                发票金额<div class="item-price-num">￥{{i.amount}}</div>
              </div>
              <div class="invoice-title">
                <div>发票抬头</div>
                <div>
                  <div class="company-name">{{ i.gmfMc }}</div>
                  <div v-if="i.gmfNsrsbh" class="company-nsrsh">税号&nbsp;&nbsp; {{i.gmfNsrsbh}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="invoice-detail" v-if="invoiceDetail && invoiceDetail.length > 0">
          <div class="invoice-type" v-if="invoiceDetail[0].gmfMobile">
            <div class="invoice-type-left">
              手机号
            </div>
            <div class="invoice-type-right">
              <div class="invoice-num">
                {{invoiceDetail[0].gmfMobile}}
              </div>
            </div>
          </div>
          <div class="invoice-type" v-else>
            <div class="invoice-type-left">
              邮箱地址
            </div>
            <div class="invoice-type-right">
              <div class="invoice-num">
                {{invoiceDetail[0].gmfEmail}}
              </div>
            </div>
          </div>
          <div class="invoice-type">
            <div class="invoice-type-left">
              发票类型
            </div>
            <div class="invoice-type-right">
              <div class="invoice-num">
                增值税普通发票（电子发票）
              </div>
            </div>
          </div>
          <div class="invoice-type">
            <div class="invoice-type-left">
              开票方
            </div>
            <div class="invoice-type-right">
              <div class="invoice-num">
                {{invoiceCompany}}
              </div>
            </div>
          </div>
          <div class="invoice-type">
            <div class="invoice-type-left">
              发票内容
            </div>
            <div class="invoice-type-right">
              <div class="invoice-num">
                {{invoiceContent}}
              </div>
            </div>
          </div>
        </div>
        <div class="invoice-footer">
          <div v-if="invoiceStatus!==2" :class="{'resendBtn-main':invoiceStatus===3 && invoiceStatus!==1}" style="display: flex;align-items: center;gap: 9px">
            <div v-if="invoiceStatus===1">
              <div class="resendBtn" @click="rebillingSubmit" v-if="isReopenInvoice">
                重开发票
              </div>
              <div class="resendBtn" style="background: #f5f5f5;color: #c4c4c4" v-if="!isReopenInvoice">
                重开发票
              </div>
            </div>
            <div v-if="invoiceStatus==3" class="resendBtn gray">
              重新发送
            </div>
            <div v-else class="resendBtn" @click="resendSubmit">
              重新发送
            </div>
          </div>
          <div v-else>
            <div class="resendBtn" style="width: 345px;" @click="rebillingSubmit">
              开发票
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="noData" v-else>
      暂无开票记录
    </div>
    <div class="invoice-tips-con" v-if="isShowInvoiceTips">
      <div class="invoice-reissued-tips">
        <div class="invoice-reissued-tips-title">温馨提示</div>
        <div class="invoice-reissued-tips-content">
          <div>重开发票会作废历史已开具发票</div>
        </div>
        <div class="tips-btn">
          <div class="btn-left" @click="rebillingSubmit">取消</div>
          <div class="btn-right" @click="confirmAnewInvoice">确认</div>
        </div>
      </div>
    </div>
    <BottomPopup :show="isShowReceiveInfo"
                 title="填写接收信息"
                 @close="isShowReceiveInfo=false"
    >
      <div class="addInvoice-con receive-info" v-if="true">
        <div class="addInvoice-main">
          <div class="addInvoice-form">
            <div class="addInvoice-item">
              <div class="addInvoice-item-title">选择方式：</div>
              <div class="addInvoice-item-content">
                <div class="receive-tab-item" :class="{active : receiveType===1}" @click="changeReceiveType(1)">
                  邮箱
                </div>
                <div class="receive-tab-item" :class="{active : receiveType===2}" @click="changeReceiveType(2)">
                  手机号
                </div>
              </div>
            </div>
            <div class="addInvoice-item" v-if="receiveType===1">
              <div class="addInvoice-item-title">邮箱地址：</div>
              <div class="addInvoice-item-content" style="margin: 15px 0;">
                <input type="text" v-model="receiveInfoValue" placeholder="邮箱地址为必填">
              </div>
            </div>
            <div class="addInvoice-item"  v-if="receiveType===2">
              <div class="addInvoice-item-title">手机号：</div>
              <div class="addInvoice-item-content" style="margin: 15px 0;">
                <input type="text" v-model="receiveInfoValue" placeholder="手机号为必填">
              </div>
            </div>
            <div class="receiveInfo-tips">
              <div v-if="verifyReceiveFormMsg" class="noFilled"><img src="https://resource.rcclchina.com.cn/invoice/notFilled-icon.png" alt="">{{verifyReceiveFormMsg}}</div>
            </div>
            <div class="addInvoiceBtn" @click="saveReceiveInfo">提交</div>
          </div>
        </div>
      </div>
    </BottomPopup>
  </div>
</template>
<script>
import api from "@/api";
import BottomPopup from "@/components/Booking/BottomPopup.vue";
import {isEmpty} from "@/utilities/tools";

export default {
  components: {BottomPopup},
  data () {
    return {
      invoiceApplyId:'',
      invoiceDetail:null,
      isInvoiceCompleted:'',
      isShowInvoiceTips:false,
      isShowReceiveInfo:false,
      receiveInfoValue:'',
      receiveType:1,
      verifyReceiveFormMsg:'',
      invoiceStatus:'',
      isReopenInvoice:false,
      bookingRecordIds:'',
      invoiceCompany:'开票方为皇家加勒比游轮船务（中国）有限公司',
      invoiceContent:'旅游服务*代订住宿费',
    }
  },
  mounted() {
    this.initPage()
  },
  beforeMount () {
    this.$store.commit('SET_PAGE_TITLE', '发票进度')
    this.$store.dispatch('HIDE_HEADER_BAR', {isHideHeader: false, isHideFooter: true})
  },
  methods: {
    initPage(){
      let query = this.$route.query
      this.invoiceApplyId = query.invoiceApplyId
      this.getInvoiceInfo()
    },
    async getInvoiceInfo() {
      let params = {
        invoiceApplyId: this.invoiceApplyId,
        userName:this.$store.state.user.userToken
      }
      this.$loading.show()
      let {success, data, errMsg} = await api.booking.getBookingRecordInvoice(params)
      this.$loading.hide()
      if(success){
        if(data && data.invoiceApplyOrderList && data.invoiceApplyOrderList.length > 0){
          this.invoiceStatus = data.status
          this.isReopenInvoice = data.isReopenInvoice
          data.invoiceApplyOrderList.forEach(item=>{
            if(item.amount%1 === 0) {
              item.amount = item.amount + '.00'
            }
          })
          let bookingRecordIds = []
          data.invoiceApplyBookingDetailViewModel.forEach(item=>{
            bookingRecordIds.push(item.bookingRecord_Id)
          })
          this.bookingRecordIds = bookingRecordIds.join(',')
        }
        this.invoiceDetail = data.invoiceApplyOrderList
        this.invoiceCompany = data.xsfMc
        this.invoiceContent = data.invoiceContent
      }else{
        this.$alert.show(errMsg);
      }
    },
    formatDateString(dateString, addHours = 0) {
      if(isEmpty(dateString)) return "";
      const date = new Date(dateString);
      date.setHours(date.getHours() + addHours);
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${month}月${day}日${hours}:${minutes}`;
    },
    resendSubmit() {
      this.isShowReceiveInfo = true
    },
    async saveReceiveInfo() {
      // 验证邮箱
      this.verifyReceiveFormMsg = ''
      if (this.receiveType === 1) {
        let reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
        if (this.receiveInfoValue.trim() === '') {
          this.verifyReceiveFormMsg = '请填写邮箱地址'
        } else {
          if (!reg.test(this.receiveInfoValue)) {
            this.verifyReceiveFormMsg = '请填写正确的邮箱地址'
          }
        }
      } else {  // 验证手机号
        let reg = /^1[3456789]\d{9}$/
        if (this.receiveInfoValue.trim() === '') {
          this.verifyReceiveFormMsg = '请填写手机号'
        } else {
          if (!reg.test(this.receiveInfoValue)) {
            this.verifyReceiveFormMsg = '请填写正确的手机号'
          }
        }
      }
      if (this.verifyReceiveFormMsg !== '') return
      this.isShowReceiveInfo = false
      let params = {
        InvoiceApplyId: this.invoiceDetail[0].invoiceApplyId,
        Mobile:this.receiveType===2 ? this.receiveInfoValue : '',
        Email:this.receiveType===1 ? this.receiveInfoValue : '',
      }
      this.$loading.show()
      let {success, errMsg} = await api.booking.resendInvoice(params)
      this.$loading.hide()
      if (success) {
        this.$alert.show('重新发送成功')
        setTimeout(()=>{
          this.isShowReceiveInfo = false
        },1500)
      } else {
        this.$alert.show(errMsg);
      }
    },
    rebillingSubmit(){
      this.isShowInvoiceTips = !this.isShowInvoiceTips
    },
    confirmAnewInvoice(){
      this.$router.push({
          path: '/Rccl.Booking/Booking/InvoiceDetails',
          query: {
            bookingRecordIds: this.bookingRecordIds,
            invoiceApplyId: this.invoiceDetail[0].invoiceApplyId
          }
      })
    },
    changeReceiveType(type){
      this.receiveType = type
    },
  },
}
</script>
<style lang="less" scoped>
.invoice-details-progress{
  background-color: #f5f5f5;
  position: relative;
  padding-bottom: 27px;
  .progress-con{
    width: 100%;
    margin: 0 auto;
    padding-bottom: 24px;
    .progress-header{
      height: 196px;
      background-color: #fff;
      position: relative;
      .progress-title{
        width: 100%;
        height: 196px;
        display: flex;
        box-sizing: border-box;
        font-size: 16px;
        color: #ffffff;
        padding: 14px 0 0 14px;
        background: linear-gradient( 225deg, #00AEEA 0%, #006AB6 100%);
      }
      .progress-detail{
        padding: 15px 0 0 15px;
        width: 100%;
        height: 148px;
        box-sizing: border-box;
        position: absolute;
        top: 48px;
        left: 0;
        z-index: 9;
        box-shadow: 0 2px 10px 0 rgba(0,0,0,0.1);
        border-radius: 10px 10px 0 0;
        background-color: #fff;
        .detail-title{
          color: #282828;
          font-size: 16px;
          font-weight: bold;
        }
        .detail-detail-con{
          margin: 10px auto 0;
          .detail-image{
            width: 100%;
            height: 18px;
            margin: 0 auto;
            img{
              width: 100%;
              height: 100%;
            }
          }
          .detail-date{
            width: 100%;
            text-align: center;
            font-size: 14px;
            color: #999999;
            .detail-date-item{
              display: flex;
              align-items: center;
              gap: 11px;
              margin: 13px auto 0;
              position: relative;
              .progress-date{
                font-size: 12px;
              }
              .radius{
                width: 9px;
                height: 9px;
                border: 1px solid #F8C533;
                border-radius: 50%;
              }
              .noRadius{
                background-color: #CCCCCC;
                border: none;
              }
              .line{
                width: 1px;
                height: 22px;
                position: absolute;
                background-color: #F8C533;
                left: 4px;
                bottom: 16px;
              }
            }
            .active{
              color: #F8C533;
              font-weight: 500;
              .progress-date{
                font-size: 12px;
                color: #999999;
                font-weight: 500;
              }
              .radius{
                border: none;
                background-color: #F8C533;
              }
            }
          }
        }
      }
    }
    .progress-main{
      width: 100%;
      background-color: #fff;
      box-sizing: border-box;
      margin-top: 10px;
      padding: 14px 15px;
      .detail-title{
        width: 100%;
        margin: 0 auto;
        color: #333333;
        font-size: 17px;
        font-weight: bold;
      }
      .invoice-info{
        width: 100%;
        padding: 11px 0;
        box-sizing: border-box;
        .info-item{
          width: 100%;
          height: 117px;
          background-color: #f6f6f6;
          border-radius: 8px;
          padding: 0 37px 0 22px;
          font-size: 12px;
          color: #282828;
          margin-bottom: 7px;
          cursor: pointer;
          .item-con{
            padding-top: 12px;
            .invoice-index{
              font-weight: 600;
              font-size: 14px;
            }
            .invoice-title{
              display: flex;
              gap: 27px;
              margin-top: 8px;
            }
            .company-name{
              width: 210px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              font-weight: 500;
            }
            .company-nsrsh{
              font-weight: 500;
              font-size: 12px;
            }
          }
          .item-price{
            display: flex;
            align-items: center;
            gap: 27px;
            margin-top: 8px;
            .item-price-num{
              color: #1c6ab6;
              font-size: 12px;
            }
          }
        }
      }
      .invoice-detail{
        //padding-left: 22px;
        padding-bottom: 15px;
        .invoice-type:last-child{
          border-bottom: none;
        }
        .invoice-type {
          width: 100%;
          display: flex;
          font-size: 12px;
          border-bottom: 1px #EDEDED solid;
          padding: 12px 15px;
          margin: 0 auto;
          .invoice-type-left {
            color: #999999;
            min-width: 80px;
            text-align: left;
          }
          .invoice-type-right {
            color: #282828;
            cursor: pointer;
            .right-tips {
              padding-left: 27px;
            }
          }
        }
      }
      .invoice-footer{
        display: flex;
        align-items: center;
        gap: 52px;
        justify-content: center;
        width: 100%;
        height: 75px;
        background-color: #fff;
        position: fixed;
        bottom: 0;
        left: 0;
        //z-index: 11;
        box-sizing: border-box;
        box-shadow: 0px 2px 10px 0px rgba(0,0,0,0.1);
        padding: 18px 15px;
        .resendBtn{
          width: 168px;
          height: 39px;
          line-height: 39px;
          text-align: center;
          background: linear-gradient( 225deg, #00AEEA 0%, #006AB6 100%);
          border-radius: 4px;
          color: #FFFFFF;
          font-weight: bold;
          font-size: 14px;
          margin: 35px 0;
          cursor: pointer;
        }
        .gray{
          background: #e9e9e9;
          color: #a7a7a7;
        }
        .resendBtn-main .resendBtn{
          width: 345px!important;
        }
      }
    }
  }
  .invoice-tips-con{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9;
    background:  rgba(0,0,0,0.7);
    .invoice-reissued-tips{
      width: 270px;
      height: 146px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      background-color: #fff;
      text-align: center;
      box-shadow: 0px 2px 20px 0px rgba(0,0,0,0.1);
      border-radius: 8px;
      overflow: hidden;
      .invoice-reissued-tips-title{
        width: 100%;
        font-size: 21px;
        font-weight: bold;
        color: #FED311;
        margin-top: 11px;
      }
      .invoice-reissued-tips-content{
        width: 100%;
        padding: 13px 0 32px;
        font-size: 13px;
        color: #000000;
      }
      .tips-btn{
        width: 100%;
        font-size: 14px;
        color: #000000;
        display: flex;
        font-weight: 600;
        align-items: center;
        justify-content: center;
        div{
          width: 50%;
          height: 41px;
          line-height: 41px;
          cursor: pointer;
        }
        .btn-left{
          background-color: #ececec;
        }
        .btn-right{
          background: linear-gradient( 225deg, #FFDB17 0%, #FCBF00 100%);
        }
      }
    }
  }
}
.addInvoice-con {
  width: 100%;
  height: 100%;;
  display: flex;
  align-items: center;
  justify-content: center;

  .addInvoice-main {
    width: 100%;
    background-color: #fff;

    .addInvoice-title {
      font-size: 17px;
      font-weight: bold;
      color: #333333;
      text-align: center;
      padding: 8px 0;
      border-bottom: 1px solid #d9d9d9;
      position: relative;

      .popup-close {
        width: 25px;
        height: 25px;
        position: absolute;
        padding: 5px;
        right: 14px;
        top: 14px;
        cursor: pointer;
      }
    }

    .addInvoice-form {
      padding: 10px 0 0;

      .addInvoice-item {
        display: flex;
        align-items: center;
        position: relative;
        border-bottom: 1px solid #eee;

        .addInvoice-item-title {
          font-size: 14px;
          color: #282828;
          text-align: left;
          position: relative;

          img {
            width: 17px;
            height: 17px;
            margin-left: 5px;
            cursor: pointer;
          }
        }

        .addInvoice-item-content {
          width: 100%;
          justify-content: space-evenly;
          display: flex;
          align-items: center;
          position: relative;
          gap: 46px;
          font-size: 14px;

          .receive-tab-item {
            padding: 9px 0;
          }

          .active {
            border-bottom: #F8C533 solid 2px;
          }

          .companySelect {
            position: absolute;
            top: 31px;
            left: 0;
            width: 400px;
            background-color: #fff;
            z-index: 9;
            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
            border-radius: 6px;
            box-sizing: border-box;
            max-height: 300px;
            overflow-y: auto;

            .companySelect-item {
              padding: 5px;
              cursor: pointer;
            }

            .companySelect-item:hover {
              background-color: #f5f5f5;
            }
          }

          input[type="text"] {
            width: 100%;
            height: 31px;
            border: none;
            font-style: normal;
            font-size: 14px;
            color: #000000;
          }

          //  设置input的placeholder颜色
          ::placeholder {
            color: #D0D0D0;
          }
        }

        .invoiceTypePopup {
          width: 549px;
          height: auto;
          position: absolute;
          top: 40px;
          background-color: rgba(32, 32, 32, 0.7);
          color: #ffffff;
          font-size: 18px;
          border-radius: 20px;
          padding: 17px 30px;
          z-index: 9;

          .nsrsbh-con {
            .nsrsbh-type {
              font-size: 22px;
              font-weight: bold;
              margin-bottom: 20px;
            }

            .nsrsbh-con-item {
              position: relative;
              padding-left: 10px;
            }
          }

          .tips-dot {
            position: absolute;
            top: 13px;
            left: 0;
            transform: translate(-50%, -50%);
            display: block;
            width: 5px;
            height: 5px;
            background: #fff;
            border-radius: 50%;
            margin-right: 10px;
          }
        }
      }
      .form-tips {
        font-size: 12px;
        color: #202020;
        width: 100%;
        margin-top: 8px;
        padding-left: 126px;
      }
      .receiveInfo-tips {
        height: 20px;
        margin: 26px 0 8px;
        font-size: 10px;
        .noFilled{
          display: flex;
          align-items: center;
          gap: 5px;
          color: #fe0000;
          justify-content: center;
          img{
            display: block;
            width: 14px;
            height: 14px  ;
          }
        }
      }
      .addInvoiceBtn{
        width: 345px;
        height: 39px;
        background: linear-gradient( 225deg, #00AEEA 0%, #006AB6 100%);
        border-radius: 4px;
        font-size: 14px;
        font-weight: bold;
        line-height: 39px;
        text-align: center;
        color: #fff;
        margin: 0 auto 12px;
        cursor: pointer;
      }
    }
  }
}
.receive-info{
  padding:  0 15px;
  .addInvoice-form{
  }
  .addInvoice-item-title{
    width: 100px !important;
  }
}
.noData{
  width: 100%;
  text-align: center;
  padding-top: 50px;
  font-size: 14px;
}
</style>